import ExcelJS from "exceljs";
import downloadExcel from "@/views/Reports/downloadExcel";

class CreateWorkbook {
  createExcel(listData, fields, fileName) {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Sheet 1");
    sheet.columns = fields.map((f) => {
      return {
        key: f.key,
        header: f.header,
      };
    });
    listData.forEach((item) => {
      sheet.addRow({
        name: item.name,
        mtd: item.mtd,
        mtdLastYear: item.mtdLastYear,
        mtdPercentChanged: item.mtdPercentChanged,
        ytd: item.ytd,
        ytdLastYear: item.ytdLastYear,
        ytdPercentChanged: item.ytdPercentChanged,
        "12monthRolling": item["12monthRolling"],
        "12monthRollingLastYear": item["12monthRollingLastYear"],
        "12monthRollingPercentChanged": item["12monthRollingPercentChanged"],
      });
    });

    //get column
    const nameCol = sheet.getColumn("name");
    const mtdComma = sheet.getColumn("mtd");
    const mtdLastYearComma = sheet.getColumn("mtdLastYear");
    const ytdComma = sheet.getColumn("ytd");
    const ytdLastYearComma = sheet.getColumn("ytdLastYear");
    const monthRollingComma = sheet.getColumn("12monthRolling");
    const monthRollingLastYearComma = sheet.getColumn("12monthRollingLastYear");
    const mtdPercent = sheet.getColumn("mtdPercentChanged");
    const ytdPercent = sheet.getColumn("ytdPercentChanged");
    const monthRollingPercent = sheet.getColumn("12monthRollingPercentChanged");

    //set thousand separator
    mtdComma.numFmt = "#,###0.00";
    mtdLastYearComma.numFmt = "#,###0.00";
    ytdComma.numFmt = "#,###0.00";
    ytdLastYearComma.numFmt = "#,###0.00";
    monthRollingComma.numFmt = "#,###0.00";
    monthRollingLastYearComma.numFmt = "#,###0.00";

    //set percentage
    mtdPercent.numFmt = "0.00%";
    ytdPercent.numFmt = "0.00%";
    monthRollingPercent.numFmt = "0.00%";

    //set width
    nameCol.width = 45;
    mtdComma.width = 20;
    mtdLastYearComma.width = 20;
    ytdComma.width = 20;
    ytdLastYearComma.width = 20;
    monthRollingComma.width = 20;
    monthRollingLastYearComma.width = 20;

    workbook.xlsx
      .writeBuffer()
      .then((res) => {
        downloadExcel.downloadFile(res, fileName);
      })
      .catch((ex) => console.log("Error: ", ex));
  }
}

export default new CreateWorkbook();
